import { Reveal } from "@/components/common/Reveal";
import { SectionHeading } from "@/components/common/SectionHeading";
import { Marquee } from "@/components/common/Marquee";

export function Vision() {
  return (
    <section className="relative py-28 sm:py-36 radial-gold" data-testid="vision">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="grid gap-14 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20 items-start">
          <SectionHeading
            eyebrow="Notre vision"
            lines={["Un groupe.", "Plusieurs savoir-faire.", "Une vision commune."]}
          />
          <div className="space-y-6 text-base sm:text-lg text-[var(--txt-2)] font-light leading-relaxed">
            <Reveal>
              <p>
                Notre stratégie repose sur une conviction : les entreprises locales performantes peuvent aller beaucoup
                plus loin lorsqu'elles unissent leurs compétences, leurs moyens et leurs marchés.
              </p>
            </Reveal>
            <Reveal delay={0.05}>
              <p>
                Chaque entreprise possède son histoire, ses clients, ses équipes et son savoir-faire. Notre objectif
                n'est pas d'effacer cette identité.
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="text-slate-200">
                Losta Group souhaite au contraire la préserver tout en donnant à chaque entreprise les moyens
                d'accélérer son développement.
              </p>
            </Reveal>
          </div>
        </div>
      </div>

      <Reveal className="mt-24" delay={0.1}>
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
          <blockquote className="font-serif font-light tracking-tight leading-[1.1] text-3xl sm:text-5xl lg:text-6xl text-white max-w-5xl">
            Une entreprise locale conserve sa proximité.
            <span className="block text-gold mt-2">Un groupe lui ouvre de nouvelles possibilités.</span>
          </blockquote>
        </div>
      </Reveal>

      <div className="mt-24 border-y border-white/10 py-6">
        <Marquee items={["Enseignes", "Signalétique", "Impression numérique", "Covering", "Smart Glass", "Métallerie", "Éclairage LED", "Portails"]} />
      </div>
    </section>
  );
}
